import React from 'react';
import classNames from 'classnames';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface KeplerModeButtonProps {
    id: string;
    buttonLabel: string;
    dropdownVisible: boolean;
    onItemSelected: (props: any) => void;
    styles: any;
}

function ButtonListItemTooltip(name: string) {
    return <Tooltip id="button-list-item-tooltip">{name}</Tooltip>;
}

export const KeplerModeButton: React.FC<KeplerModeButtonProps> = ({
    id,
    buttonLabel,
    dropdownVisible,
    onItemSelected,
    styles
}) => {
    const isActive = !!dropdownVisible;

    const handleModeClick = (e: React.MouseEvent) => {
        e.preventDefault();
        const modeToActionMap: { [key: string]: string } = {
            'Graph': 'toggle-kepler-graph',
            'Graph + Map': 'toggle-kepler-hybrid',
            'Map': 'toggle-kepler-map'
        };
        const actionId = modeToActionMap[buttonLabel];
        if (actionId) {
            onItemSelected({ id: actionId, selected: true });
        }
    };

    const getModeIcon = () => {
        const modeToIconMap: { [key: string]: string } = {
            'Graph': 'fa fa-share-alt',
            'Graph + Map': 'fa fa-sitemap',
            'Map': 'fa fa-map'
        };
        return modeToIconMap[buttonLabel];
    };

    const modeButtonContent = (
        <div className={styles['kepler-mode-button']}>
            <span className={styles['kepler-mode-button-inner']}>
                <i className={getModeIcon()} />
                <span className={styles['kepler-mode-button-text']}>{buttonLabel || 'Graph'}</span>
            </span>
        </div>
    );

    const handleClick = (e: React.MouseEvent) => {
        handleModeClick(e);
    };

    const handleMouseEnter = () => {
        if (!dropdownVisible) {
            onItemSelected({ id, selected: true });
        }
    };

    return (
        <OverlayTrigger
            trigger={[]}
            placement="bottom"
            overlay={ButtonListItemTooltip(buttonLabel)}>
            <Button
                id={id}
                active={isActive}
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                className={classNames({
                    [styles[id]]: true,
                    'fa-fw': true,
                    [styles['selected']]: isActive,
                    [styles['button-list-item']]: true
                })}>
                {modeButtonContent}
            </Button>
        </OverlayTrigger>
    );
};
